import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/index.styles'

const RowSkeleton = () => {
  const classes = useStyles()
  return (
    <div>
      <div className={classes.fullRow}>
        <Typography variant="h4">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
    </div>
  )
}

export default RowSkeleton
